import React, { useState } from 'react';
import { OnboardingFormData } from '..';
import { Mail } from 'iconoir-react';

interface TrustedContactStepProps {
  formData: OnboardingFormData;
  updateFormData: (data: Partial<OnboardingFormData>) => void;
  onNext: () => void;
  onSkip: () => void;
}

const TrustedContactStep: React.FC<TrustedContactStepProps> = ({
  formData,
  updateFormData
}) => {
  const [trustedEmail, setTrustedEmail] = useState(formData.trustedEmail || '');
  const [emergencyEmail, setEmergencyEmail] = useState(formData.emergencyEmail || '');

  // Update parent form data when emails change
  React.useEffect(() => {
    updateFormData({
      trustedEmail,
      emergencyEmail,
    });
  }, [trustedEmail, emergencyEmail, updateFormData]);

  return (
    <div className="flex flex-col items-center justify-center px-4 py-6 space-y-6 bg-[#FBF6F1]">
      {/* Illustration - Hidden for now */}
      <div className="flex flex-col justify-center items-center gap-2.5">
        <img src="/icons/trusted-contact-illustration.svg" alt="Trusted Contact" className="w-34 h-34" />
      </div>

      {/* Title */}
      <div className="text-center">
        <h1 className="text-2xl font-semibold font-inter text-midnight-blue leading-7">
          Thêm người thân tin cậy <br/>vào Locuno
        </h1>
      </div>

      {/* Description */}
      <div className="text-center max-w-sm">
        <p className="text-sm font-normal font-inter text-midnight-blue/60 leading-tight">
          Cho phép người thân của bạn nhận các cập nhật an toàn quan trọng và được thông báo bởi hàng xóm trong trường hợp khẩn cấp.
        </p>
      </div>

      {/* Email Inputs */}
      <div className="w-full max-w-sm flex flex-col gap-3">
        <div className="h-12 p-3.5 rounded-md outline outline-1 outline-offset-[-1px] outline-[#D1D1D0] flex items-center gap-2">
          <div className="size-5 relative overflow-hidden">
            <Mail className="w-5 h-5 text-[#757575]" />
          </div>
          <input
            type="email"
            placeholder="Email của người thân"
            value={trustedEmail}
            onChange={(e) => setTrustedEmail(e.target.value)}
            className="flex-1 bg-transparent outline-none text-midnight-blue/60 text-sm font-normal font-inter"
          />
        </div>
        <div className="h-12 p-3.5 rounded-md outline outline-1 outline-offset-[-1px] outline-[#D1D1D0] flex items-center gap-2">
          <div className="size-5 relative overflow-hidden">
            <Mail className="w-5 h-5 text-[#757575]" />
          </div>
          <input
            type="email"
            placeholder="Email liên hệ khẩn cấp"
            value={emergencyEmail}
            onChange={(e) => setEmergencyEmail(e.target.value)}
            className="flex-1 bg-transparent outline-none text-midnight-blue/60 text-sm font-normal font-inter"
          />
        </div>
      </div>

      {/* Footer Note */}
      <div className="text-center max-w-sm">
        <p className="text-xs font-normal font-inter text-midnight-blue/60 leading-none">
          Danh bạ của bạn sẽ được mời tham gia nếu họ chưa phải là hàng xóm của bạn trên Locuno
        </p>
      </div>
    </div>
  );
};

export default TrustedContactStep;